﻿import React from 'react';
import { str_isEmpty } from '@Util/Utils';
import { Table_Head_Type } from '@Util/Types';

import { Icon_Arrow_Right } from '@Elements/ImageElements/Icons';

export default function Table_Head(p: Table_Head_Type): JSX.Element {
    // RENDERS ARROW ICON IF COLUMN IS ACTIVELY SORTED
    function renderArrowIconWhenActive(col: string): JSX.Element {
        if (p?.activeSortingColumn === col)
            return <Icon_Arrow_Right />;
    }

    // RENDERS ASCENDING OR DESCENDING CLASS
    function renderAscendingOrDescendingClass(col: string): string {
        if (col === p?.activeSortingColumn) {
            if (p?.sortDirection == "Ascending") {
                return "Ascending";
            } else {
                return "Descending";
            }
        }
    }

    function generateClassName(): string {
        let classStr: string = "Table_Head";

        if (!str_isEmpty(p.className)) {
            classStr += ` ${p.className}`;
        }

        if (p.sortingAction) {
            classStr += ` Table_Head_Clickable ${renderAscendingOrDescendingClass(p?.sortingDataName)}`;
        }

        return classStr;
    }

    return (
        <>
            {
                p?.sortingAction ?
                    <th
                        align={p?.align}
                        className={generateClassName()}
                        onClick={() => p?.sortingAction(p?.sortingDataName)}
                        colSpan={p?.colSpan}
                        style={p?.style}
                    >
                        <div className="Table_Head_Arrow_Wrapper">
                            {p.text}
                            {renderArrowIconWhenActive(p?.sortingDataName)}
                        </div>
                    </th> :
                    <th
                        align={p?.align}
                        className={generateClassName()}
                        colSpan={p?.colSpan}
                        style={p?.style}
                    >
                        {p.text}
                    </th>
            }
        </>
    );
}